<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h4>Partnerreport</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 desktopFilter">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Partner</mat-label>
                    <mat-select [(ngModel)]="currentPartner">
                        <mat-option *ngFor="let partner of partners" [value]="partner">
                            {{partner?.name}}</mat-option>
                        <div class="partnerEmptyState">
                            <span *ngIf="partners.length == 0">Keine Partner gefunden</span>
                        </div>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <!-- <div class="col-sm-2">
            <mat-checkbox class="example-margin" [(ngModel)]="allEvents"
                matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)" [matTooltipPosition]="'above'">
                alle Aktionen
            </mat-checkbox>
        </div> -->
    </div>

    <div class="col-sm-12 marginBottom2Rem">
        <button mat-button mat-raised-button color="accent" (click)="showAllEvents()">
            Anwenden
        </button>
        <!-- <button mat-button mat-raised-button color="primary" (click)="resetFitler()" style="margin-left: 15px;"
            [disabled]="!this.filterForm.touched">
            Filter zurücksetzen
        </button> -->
    </div>
</div>
<div class="container" *ngIf="hasSelectedPartner === true && notEnoughEvents === false">
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Aktionen, die Kunden zur Verfügung stehen"
                        [matTooltipPosition]="'above'">Aktive Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="eventCount != 0; else loading">{{ eventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                        [matTooltipPosition]="'above'">Alle Aktionen:</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h2 *ngIf="alleventCount != 0; else loading">{{ alleventCount}}</h2>
                    <ng-template #loading>
                        <mat-spinner [diameter]="35"></mat-spinner>
                    </ng-template>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <!-- TOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Top 1) {{top1Event?.title | truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.top1Event?.totalActiveReservationsCount != 0 &&  this.top1Event?.totalActiveReservationsCount!= undefined">
                        <ibm-donut-chart [data]="data_donut_1" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.top1Event != undefined && this.top1Event?.totalActiveReservationsCount != 0 ">

                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top1Event?.totalActiveReservationsCount == 0 && this.top1Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top1Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Top 2) {{top2Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.top2Event?.totalActiveReservationsCount != 0 &&  this.top2Event?.totalActiveReservationsCount!= undefined">
                        <ibm-donut-chart [data]="data_donut_2" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.top2Event != undefined && this.top2Event?.totalActiveReservationsCount != 0 ">
                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top2Event?.totalActiveReservationsCount == 0 && this.top2Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top2Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle"> Top 3) {{top3Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.top3Event?.totalActiveReservationsCount != 0 &&  this.top3Event?.totalActiveReservationsCount!= undefined">
                        <ibm-donut-chart [data]="data_donut_3" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.top3Event != undefined && this.top3Event?.totalActiveReservationsCount != 0 ">

                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top3Event?.totalActiveReservationsCount == 0 && this.top3Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.top3Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <!-- FLOP THREE EVENTS SORTED BY totalActiveReservationsCount -->
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 1) {{flop1Event?.title | truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.flop1Event?.totalActiveReservationsCount != 0 && this.flop1Event?.totalActiveReservationsCount !=  undefined">
                        <ibm-donut-chart [data]="data_donut_1_flop" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.flop1Event != undefined && this.flop1Event?.totalActiveReservationsCount != 0 ">

                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop1Event?.totalActiveReservationsCount == 0 && this.flop1Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop1Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 2) {{flop2Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.flop2Event?.totalActiveReservationsCount != 0 && this.flop2Event?.totalActiveReservationsCount !=  undefined">
                        <ibm-donut-chart [data]="data_donut_2_flop" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.flop2Event != undefined && this.flop2Event?.totalActiveReservationsCount != 0 ">

                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop2Event?.totalActiveReservationsCount == 0 && this.flop2Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop2Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Flop 3) {{flop3Event?.title| truncate : 60: false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div
                        *ngIf="finishedLoadingFlopsAndTops && this.flop3Event?.totalActiveReservationsCount != 0 && this.flop3Event?.totalActiveReservationsCount !=  undefined">
                        <ibm-donut-chart [data]="data_donut_3_flop" [options]="config_donut"></ibm-donut-chart>
                    </div>
                    <div style="height: 300px;"
                        [class.hideEmptyState]="this.flop3Event != undefined && this.flop3Event?.totalActiveReservationsCount != 0 ">

                        <div *ngIf="!finishedLoadingFlopsAndTops" class="loadingOverlay">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop3Event?.totalActiveReservationsCount == 0 && this.flop3Event != undefined"
                            class="pieChartEmptyState">
                            Für diese Aktion sind noch keine Reservierungen vorhanden.
                        </div>
                        <div *ngIf="finishedLoadingFlopsAndTops && this.flop3Event == undefined"
                            class="pieChartEmptyState">
                            Es sind nicht genügend aktive Aktionen vorhanden
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Preisnachlass</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_savings.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-simple-bar-chart [data]="data_savings" [options]="options_line_savings"
                        *ngIf="data_savings.length > 0"></ibm-simple-bar-chart>
                    <div *ngIf="data_savings.length == 0" class="pieChartEmptyState">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionstypen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_types.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_types" [options]="config_donut_types"
                        *ngIf="this.data_donut_types.length != 0">
                    </ibm-donut-chart>
                    <div *ngIf="this.data_donut_types.length == 0" class="pieChartEmptyState">
                        Keine Daten
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktioneinschränkungen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_eventLimits.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_eventLimits" [options]="config_donut_types"
                        *ngIf="this.data_donut_eventLimits.length != 0"></ibm-donut-chart>
                    <div *ngIf="this.data_donut_eventLimits.length == 0" class="pieChartEmptyState">
                        Keine Daten
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Aktionsgutscheincodes</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="data_donut_voucherStrats.length == 0"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <ibm-donut-chart [data]="data_donut_voucherStrats" [options]="config_donut_types"
                        *ngIf="this.data_donut_voucherStrats.length != 0"></ibm-donut-chart>
                    <div *ngIf="this.data_donut_voucherStrats.length == 0" class="pieChartEmptyState">
                        Keine Daten
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 marginBottom2Rem">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>
                            {{this.allEvents ? "Vergleich aller Aktionen" : "Vergleich aktiver Aktionen"}}
                        </mat-card-title>
                    </mat-card-title-group>
                    <!-- <span>
                        <mat-checkbox class="example-margin" [(ngModel)]="allEvents" (change)="showAllEvents()"
                            [disabled]="!finishedLoadingComparison"
                            matTooltip="Alle Aktionen (Aktiv, Archiviert, Abgelaufen und Versteckt)"
                            [matTooltipPosition]="'above'">
                            alle Aktionen
                        </mat-checkbox>
                    </span> -->
                </mat-card-header>
                <mat-card-content>
                    <div class="row" [formGroup]="filterTestForm">
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 1</mat-label>
                                <mat-select formControlName="serachForEvent">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 2</mat-label>
                                <mat-select formControlName="serachForEvent_2">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <mat-form-field class="full-width">
                                <mat-label>Vergleich Aktion 3</mat-label>
                                <mat-select formControlName="serachForEvent_3">
                                    <mat-option *ngFor="let option of filteredOptions" [value]="option.publicId"
                                        (click)="filterEvents()">
                                        {{option.title}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="min-height: 300px;">
                                <ibm-grouped-bar-chart [data]="data_radar" [options]="options_radar"
                                    *ngIf="finishedLoadingComparison"></ibm-grouped-bar-chart>
                                <div *ngIf="!finishedLoadingComparison" class="loadingOverlay">
                                    <mat-spinner></mat-spinner>
                                </div>
                            </div>

                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row" id="calenderRow">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card" [formGroup]="calenderFilterForm">
                <mat-card-header>
                    <mat-card-title-group>
                        <mat-card-title>Reservierungen nach Tagen</mat-card-title>
                    </mat-card-title-group>
                    <div fxFlex></div>
                </mat-card-header>
                <mat-card-content>
                    <mat-form-field class="full-width">
                        <mat-label>Event auswählen</mat-label>
                        <mat-select formControlName="event" (selectionChange)="changeEventForCalenderChart($event)">
                            <mat-option *ngFor="let sortOption of events" [value]="sortOption.value"
                                [disabled]="sortOption.state">
                                {{sortOption.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div id="calendar_basic" style="width: 100%;min-height: 300px;"></div>
                    <div *ngIf="isCalenderChartEmpty" class="pieChartEmptyState">
                        Für diese Aktion sind noch keine Reservierungen vorhanden.
                    </div>
                    <div *ngIf="!finishedLoadingCalendeData" class="loadingOverlay">
                        <mat-spinner></mat-spinner>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>
<div class="container" *ngIf="notEnoughEvents">
    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        Nicht genügend Daten
                    </mat-card-title>
                    <mat-card-subtitle>
                        Um das Reporting nutzen zu können, müssen Sie mindestens eine aktive Aktion einstellen.
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
        </div>
    </div>
</div>